<div class="container-fluid mt-3">
  <div class="row">
    @if (environment.structural || (!environment.people && !environment.structural && !environment.traffic)) {
    <mat-card class="custom-card d-flex flex-row p-0 m-2">
      <div class="card-content p-4 position-relative">
        <h3 class="fw-bold">{{ 'TITLE.STRUCTURAL_HEALTH' | translate }}</h3>
        <h3>
          {{ 'STRUCTURAL_HEALTH_DESC' | translate }}
        </h3>
        <div class="d-flex justify-content-around">
          <a mat-raised-button [routerLink]="'/infrastructure/structural-health'">
            <span class="white">
              {{ 'BUTTONS.VIEW' | translate }}
            </span> </a>
        </div>
      </div>
      <div class="card-image">
        <img src="../../../assets/img/structural.jpg" class="view-card-img">
      </div>
    </mat-card>

    }

    @if (environment.people || (!environment.people && !environment.structural && !environment.traffic)) {
    <mat-card class="custom-card d-flex flex-row p-0 m-2">
      <div class="card-content p-4 position-relative">
        <h3 class="fw-bold">{{ 'TITLE.PEOPLE_MOVEMENT' | translate }}</h3>
        <h3>
          {{ 'PEOPLE_MOVEMENT_DESC' | translate }}
        </h3>
        <div class="d-flex justify-content-around">
          <a mat-raised-button [routerLink]="'/stations/passenger-flow'">
            <span class="white">
              {{ 'BUTTONS.VIEW' | translate }}
            </span>
          </a>
        </div>
      </div>
      <div class="card-image">
        <img src="../../../assets/img/people.jpg" class="view-card-img">
      </div>
    </mat-card>
    }

    @if (environment.traffic || (!environment.people && !environment.structural && !environment.traffic) ||
    (environment.traffic && environment.structural)) {
    <mat-card class="custom-card d-flex flex-row p-0 m-2">
      <div class="card-content p-4 position-relative">
        <h3 class="fw-bold">{{ 'TITLE.TRAFFIC_MONITORING' | translate }}</h3>
        <h3>
          {{ 'TRAFFIC_MONITORING_DESC' | translate }}
        </h3>
        <div class="d-flex justify-content-around">
          <a mat-raised-button [routerLink]="'/infrastructure/traffic-monitoring'">
            <span class="white">
              {{ 'BUTTONS.VIEW' | translate }}
            </span>
          </a>
        </div>
      </div>
      <div class="card-image">
        <img src="../../../assets/img/traffic.jpg" class="view-card-img">
      </div>
    </mat-card>
    }
  </div>
</div>